import React from 'react';
import Main from '../Components/Main';
import Seo from '../Components/Seo';
import NodeSideBar from '../Components/NodeSideBar';
import BecomeNodeRunner from '../Fragments/BecomeNR/BecomeNodeRunner';
import { useAppSelector } from '../hooks';
import OptOut from '../Fragments/BecomeNR/OptOut';
import About from '../Fragments/BecomeNR/About';

export default function Nodes() {
  const pageSelection = useAppSelector(state => state.subscription.nodePageSelection);
  const displayFragment = () => {
    switch(pageSelection){
    case 'joinnr':
      return <BecomeNodeRunner />
    case 'leavenr':
      return <OptOut />
    case 'about':
      return <About />
    }
  }

  return (
    <Main>
      <Seo title="Feeds" />
      <div className="flex  min-h-screen flex-row">
        <NodeSideBar />
        <div className="flex  flex-col flex-grow pt-5 bg-gray-50">
          {displayFragment()}
        </div>
      </div>
    </Main>
  );
}
